/* Pure Desi Diwali 2026 landing v2: enhance-only reveals. Content is visible without JS; CSS unhides after 3 s regardless. */
(function(){
  if (document.documentElement.classList.contains('pd-js')) return;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (rm || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('pd-js');
  var els = document.querySelectorAll('.pd-dw2 .rv');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function(e){ io.observe(e); });
  setTimeout(function(){ els.forEach(function(e){ e.classList.add('in'); }); }, 2500);
})();

/* 26 Sep 2026: hero loop (motion idea 1; Abhi: "build idea 1 and push live"). Record: Website/Live Theme Rounds/2026-09-26-hero-loop/README.md
   7.8 s of Factory Shoot 2025 footage, silent, over the hero photo on the homepage and the Diwali page. The photo is still
   the first thing painted; the video is added after the page has loaded and fades in only once it is actually playing.
   Not added on "reduce motion", Data Saver or 2G. If autoplay is refused (iPhone Low Power Mode) the photo just stays.
   Paused while off screen. The pause button (WCAG 2.2.2) is remembered for the visit. Files live in Shopify Files. */
(function () {
  if (window.__pdHeroLoop) return; window.__pdHeroLoop = 1;
  var boxes = document.querySelectorAll('.pd-dw2 .hv__media');
  if (!boxes.length || !window.matchMedia) return;
  var rm = matchMedia('(prefers-reduced-motion: reduce)'), small = matchMedia('(max-width: 767px)'), mid = matchMedia('(max-width: 60em)'), cn = navigator.connection || {};
  if (rm.matches || cn.saveData || /(^|-)2g$/.test(cn.effectiveType || '')) return;
  /* Three cuts to match the three hero boxes: phones get a 2.6:1 strip (pd-qw.css makes the phone hero picture a 150px /
     118px strip), tablets the 4:3 cut (its file is named "phone"), desktops the 16:9 cut framed right of the text veil. */
  var SRC = { strip: '/cdn/shop/files/pd-hero-loop-strip-2026-09-26.mp4?v=1790406975',
              tablet: '/cdn/shop/files/pd-hero-loop-phone-2026-09-26.mp4?v=1790406561',
              desktop: '/cdn/shop/files/pd-hero-loop-desktop-2026-09-26.mp4?v=1790406561' };
  var KEY = 'pd-hero-loop-paused';
  function isPaused() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setPaused(p) { try { sessionStorage.setItem(KEY, p ? '1' : '0'); } catch (e) {} }
  function src() { return small.matches ? SRC.strip : mid.matches ? SRC.tablet : SRC.desktop; }
  function on(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  function build(box) {
    if (box.querySelector('.hv__loop')) return;
    var v = document.createElement('video'), b = document.createElement('button');
    v.className = 'hv__loop'; v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
    ['muted', 'playsinline', 'webkit-playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
    v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1');
    b.type = 'button'; b.className = 'hv__loopbtn'; b.hidden = true;
    box.insertBefore(v, box.querySelector('.hv__veil')); box.appendChild(b);
    var want = !isPaused(), inView = false, gone = false;
    function show() { box.classList.add('hv--loop-on'); b.hidden = false; }
    function drop() { gone = true; box.classList.remove('hv--loop-on'); v.removeAttribute('src'); v.load(); v.remove(); b.remove(); }
    function label() { b.setAttribute('aria-label', want ? 'Pause the video' : 'Play the video'); b.classList.toggle('is-paused', !want); }
    function sync() {
      if (gone) return;
      if (!want || !inView) { v.pause(); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError' && !box.classList.contains('hv--loop-on')) drop(); });
    }
    v.addEventListener('playing', show);
    v.addEventListener('loadeddata', function () { if (!want) show(); });   /* paused earlier in the visit: show the first frame + Play */
    v.addEventListener('error', function () { if (v.getAttribute('src')) drop(); });
    b.addEventListener('click', function () { want = !want; setPaused(!want); label(); sync(); });
    label();
    v.src = src();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[es.length - 1].isIntersecting; sync(); }, { threshold: 0.15 }).observe(box);
    } else { inView = true; sync(); }
    function swap() { if (gone) return; var s = src(); if (v.getAttribute('src') === s) return; var t = v.currentTime; v.src = s; try { v.currentTime = t; } catch (e) {} sync(); }
    on(small, swap); on(mid, swap);
    on(rm, function (e) { if (e.matches) drop(); });
  }
  function start() { boxes.forEach(build); }
  if (document.readyState === 'complete') setTimeout(start, 250);
  else window.addEventListener('load', function () { setTimeout(start, 250); });
})();
